<div class="container-fluid">
  <div class="row">
    <div class="d-md-block col-12 col-md-6 px-0">
      <div class="d-none d-md-block banner-container min-w" *ngIf="showBannerInit">
        <!-- <div class="banner-effect"></div> -->
        <img class="guy" src="https://static.monific.com/assets/assets-app/img/guy-img.png" alt="">
        <!-- carrousel testimonials -->
        <div class="testimonial-carousel">
          <owl-carousel-o [options]="customOptions" id="carouse-testimonials">
            @for(item of testimonies; track $index) {
            <ng-template carouselSlide>
              <div class="animated fadeIn col px-lg-4 p-4 bg-primary2 container-testimonials">
                <div class="d-flex justify-content-end">
                  <img class="image1" src="https://static.monific.com/assets/assets-app/img/Stars-test.png" alt="testimonials-stars">
                </div>
                <p class="my-3 cl-white text-justify fs-15">{{ item?.description }}</p>
                <div class="d-flex">
                  <img class="image2" src="https://static.monific.com/assets/assets-app/img/user-test.svg" alt="avatar-image">
                  <div>
                    <p class="fw-sbold fs-16 cl-white inv">{{ item?.name }}</p>
                    <p class="cl-white fs-16 inv">Inversionista en Monific</p>
                  </div>
                </div>
              </div>

            </ng-template>
            }
          </owl-carousel-o>
        </div>
      </div>
      <div class="banner-container2" *ngIf="!showBannerInit">
        <div class="slider-container" *ngIf="isVisible">
          <owl-carousel-o [options]="customOptions" id="carouse-testimonials2">
            <ng-template carouselSlide *ngFor="let item of items; let i = index">
              <div class="slide-content">
                <div class="item animated fadeIn adjust-slider">
                  <img class="main-image" [src]="item.imagen" alt="{{ item.texto }}" />
                  <img class="mt-4 cont-icon" [src]="item.icon" alt="{{ item.texto }}" />
                  <h3 class="mt-3">{{ item.subtitle }}</h3>
                  <p class="mt-1">{{ item.texto }}</p>
                </div>
              </div>
            </ng-template>
          </owl-carousel-o>
        </div>
        <div class="item animated fadeIn slider-container2" *ngIf="!isVisible">
          <img class="main-imag" src="https://static.monific.com/assets/assets-app/sliders/slider_8.svg" alt="">
          <h3 class="mt-4">¡Solicita hasta $60 millones, de forma flexible! </h3>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 px-0 min-w">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div>
    <mnf-authentication-banner></mnf-authentication-banner>
  </div>
</div>